export default "__VITE_ASSET__BJRC6zt6__"